import { FormCard, FormItem, TextArea } from '@lmc/ui-kit'
import { FC } from 'react'
import styled from 'styled-components'
import { Text } from '@lmc/ui-kit/src/general'
import { AdlSectionExtended } from '@lmc/ts-common'
import { colours } from '@lmc/ui-kit/src/config/theme'

type Props = {
  section: AdlSectionExtended
  isViewMode?: boolean
  value?: string
}

export const CarePlanSection: FC<Props> = ({
  section: { key, label, helpText, color },
  isViewMode,
  value
}) => {
  return (
    <StyledFormCard
      title={label}
      subtitle={helpText}
      leftChildren={
        <div
          style={{
            height: 40,
            width: 40,
            backgroundColor: color,
            borderRadius: 5,
            marginRight: 10
          }}
        />
      }
    >
      <SectionWrapper key={key}>
        <FormItem name={key}>
          {!isViewMode && (
            <TextArea
              placeholder="Type here ..."
              autoSize={{
                minRows: 3
              }}
            />
          )}
          {isViewMode && (
            <TextArea
              style={{
                backgroundColor: 'transparent',
                border: 'none',
                cursor: 'none',
                color: colours.neutral.color2
              }}
              placeholder="Type here ..."
              autoSize={{
                minRows: 3
              }}
              disabled
              defaultValue={value}
            />
          )}
        </FormItem>
      </SectionWrapper>
    </StyledFormCard>
  )
}

const SectionWrapper = styled.div``

const StyledFormCard = styled(FormCard)`
  margin-bottom: 24px;
`
